import React, { useContext, useState } from "react";
import firebaseApp from "../index";
import { getAuth, onAuthStateChanged } from "firebase/auth";
const AppContext = React.createContext([]);
export const useAppContext = () => useContext(AppContext);

const ContextProvider = ({ children }) => {
    const auth = getAuth(firebaseApp);
    const [usuarioGlobal, setUsuarioGlobal] = useState(null);
    const [correoUsuario, setCorreoUsuario] = useState(null);
    onAuthStateChanged(auth, (usuarioFirebase) => {
        if (usuarioFirebase) {
            setUsuarioGlobal(usuarioFirebase);
            setCorreoUsuario(usuarioGlobal.email);
            console.log(usuarioFirebase);
        } else {
            setUsuarioGlobal(null);
            setCorreoUsuario(null);
            console.log(usuarioFirebase);
        }
    });

    return (
        <AppContext.Provider
            value={{
                usuarioGlobal,
                correoUsuario,
            }}
        >
            {children}
        </AppContext.Provider>
    );
};

export default ContextProvider;
